<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="logo" alt="Phovius Logo" height="55">
        <img class="navbar-brand-minimized logo-width" src="img/logo_small.png" alt="Phovius Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
       <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3">{{username}}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto d-sm-down-none">
        <b-form-select v-if="showDealer" class="mb-1" :options="dealerItems" v-model="dealer" disabled-field="notEnabled" @change="updateDealer(true)"/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader class="d-md-none d-lg-none d-xl-none" v-if="showDealer">
          <b-navbar-nav>
            <b-form-select :options="dealerItems" v-model="dealer" disabled-field="notEnabled" @change="updateDealer(true)"/>
          </b-navbar-nav>
        </SidebarHeader>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div class="ml-auto">
        <span class="mr-1">Powered by Impelos</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import Vue from 'vue'
import nav from '@/_nav'
import { getUserInfo } from '../_helpers'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'

let newVue = new Vue({});

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: [],
      username:'',
      dealerItems:[],
      dealer:0,
      showDealer:false,
      logo:'img/logo.png'
    }
  },
  created(){
    const user = getUserInfo()
    this.username = user.name
    if(user.logoimage != '' && user.roleid != 1 && (user.role != 'Admin' || user.role != 'admin')){
      this.logo = user.logoimage;
    }
    if(user.roleid == 1 || user.role == 'Admin'){
      this.showDealer = true;
    }
    const rolid = user.roleid-1
    this.nav = nav.menu[rolid].items;
    this.loadCurrentDealer(true);
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    loadCurrentDealer(loadDealer){
      this.$store.dispatch('getById', {url:'user/getCurrentDealer',data :{}}).then((res) => {
        this.dealer = res.dealerID
        if(res.logo != ''){
          this.logo = res.logo
        }else{
          this.logo = 'img/logo.png'
        }
        if(loadDealer){
          this.loadDealerData();
        }
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    loadDealerData() {
      this.$store.dispatch('getById', {url:'user/loadUserData',data :{}}).then((res) => {
        if(res.dealer.length > 0){
          if(this.dealer == 0){
            this.dealer = res.dealer[0].value;
          }
        }
        res.dealer.forEach((version) => {
          this.dealerItems.push(version);
        });
        this.updateDealer(false);
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    updateDealer(reload){
      this.$store.dispatch('saveData',{url:'dealer/updateCurrentDealer',data:{dealerID : this.dealer }}).then((res) => { 
        if(reload){
          this.loadCurrentDealer(false);
          newVue.$eventHub.emit('reloadDashBoard');
          if(this.$route.path != '/home/dashboard'){
            this.$router.push('/home');
          }
        }
      },(error) =>{
      });
    }
  }
}
</script>
